import { Record } from "immutable";

import { UserModel } from "./UserModel";

const defaults = {
  id: "",
  maintainerGroupId: "",
  user: null as null | UserModel,
  userId: "",
};

export class UserMaintainerModel extends Record<typeof defaults>(defaults) implements IMaintainerModel {
  get entity(): null | UserModel {
    return this.user;
  }

  get entityId(): string {
    return this.userId;
  }

  static fromEntity(entity: UserModel): UserMaintainerModel {
    return new UserMaintainerModel({
      id: "",
      maintainerGroupId: "",
      user: entity,
      userId: entity.id,
    });
  }

  static fromServerData(data: unknown): UserMaintainerModel {
    const { id, maintainerGroupId, user, userId } = data as typeof defaults;
    return new UserMaintainerModel({
      id,
      maintainerGroupId,
      user: user ? UserModel.fromServerData(user) : null,
      userId,
    });
  }
}
